export default __webpack_public_path__ + "static/media/active-organization-icon.5736041d.svg";